import * as React from "react";
import { useRecordContext } from 'react-admin';
import { Button } from '@material-ui/core';

const BundlerTableUploadButton = (props) => {
    const record = useRecordContext(props);
    const authToken = localStorage.getItem( 'authToken' );

    const bundlerTableUpload = `https://tables.paradigms.ontariopc.ca/ticket-batches.html?${record.event_id}-${record.person_hash}-${authToken}`;
    return ( <Button href={bundlerTableUpload}>Click Here</Button> );
}

BundlerTableUploadButton.defaultProps = { label: 'Riding Transfers' };

export default BundlerTableUploadButton;
